import { equals } from 'ramda';

export default equals;
